import * as Yup from "yup";


export const addCountriesValidation = () => {
    return Yup.object({
        name: Yup.string()
            .trim()
            .required("*Country name is required")
            .max(100, "*Country name must be at most 100 characters"),

        iso_code: Yup.string()
            .trim()
            .required("*ISO code is required")
            .max(3, "*ISO code must be at most 3 characters"),
        iso_code_2: Yup.string()
            .trim()
            .max(2, "*ISO code must be at most 2 characters").nullable(),
        phone_code: Yup.string()
            .trim()
            .matches(/^[0-9]*$/, "*Mobile code must contain only digits")
            .max(6, "*Mobile code must be at most 6 digits")
            .nullable(),

        currency: Yup.string()
            .trim()
            .required("*Currency symbol is required")
            .max(3, "*Currency symbol must be at most 3 characters"),
    })
}

export const addStatesValidation = () => {
    return Yup.object({
        name: Yup.string()
            .trim()
            .required("*State name is required")
            .max(100, "*State name must be at most 100 characters"),

        country_id: Yup.mixed()
            .required("*Country is required"),

        state_code: Yup.string()
            .trim()
            .required("*State code is required")
            .max(3, "*State code must be at most 3 characters"),

    })
}


export const addCitiesValidation = () => {
    return Yup.object({
        name: Yup.string()
            .trim()
            .required("*State name is required")
            .max(100, "*State name must be at most 100 characters"),
        city_code: Yup.string()
            .trim()
            .required("*City code is required")
            .max(3, "*City code must be at most 3 characters"),


        state_id: Yup.mixed()
            .required("*State is required"),

        country_id: Yup.string()
            .trim()
            .required("*Country is required")
    })
}


